import React, { useState, useContext } from "react";
import { Drawer, Button, Divider } from "antd";
import {
	FileTextOutlined,
	AppstoreOutlined,
	ImportOutlined,
	ContainerOutlined,
	CalendarOutlined,
	UsergroupAddOutlined,
	ProfileOutlined,
	BarsOutlined,
	UserOutlined,
	EditOutlined,
	FolderOpenOutlined,
	MailOutlined,
	SoundOutlined,
	ScheduleOutlined,
	StarOutlined,
	LineChartOutlined,
	FormOutlined
} from "@ant-design/icons";
import { SecurityContext } from "../../../../context/SecurityContextProvider";
import { MenuItemMovil } from "./components/MenuMovilItem";
import { useHistory } from "react-router-dom";

import "./index.css";
import { VersionApiColaborador } from "../../../../enum/VersionApiColaborador";
import { useEffect } from "react";

export function MenuMovil({ opciones }) {
	const page = window.location.pathname.split("/")[1];
	const [menuActivo, setMenuActivo] = useState(page === "mis-documentos" ? "bandejaEntrada" : page);
	const [visibleMenuPerfil, setVisibleMenuPerfil] = useState(false);
	const { getVersionApiColaborador, cerrarSesion, getUsuarioAutenticado } = useContext(SecurityContext);

	const isAceros = getUsuarioAutenticado().empresaSeleccionada.razonSocial.toUpperCase().includes("ACEROS CHILCA SAC")
		? true
		: false;
	const isSDF = getUsuarioAutenticado().empresaSeleccionada?.ruc === "20330791684" ? true : false;
	const isSDFEnergia = getUsuarioAutenticado().empresaSeleccionada?.ruc === "20512436090" ? true : false;
	const isManuelita = getUsuarioAutenticado().empresaSeleccionada?.ruc === "20411051782" ? true : false;

	useEffect(() => {
		//Nota: Se usa para marcar activo el menu principal
		const ruta = window.location.pathname;
		switch (ruta) {
			case "/vacaciones/solicitudes":
				setMenuActivo("portal-colaborador.vacaciones");
				break;
			case "/mis-documentos":
				//setMenuActivo("bandejaEntrada");
				setMenuActivo("portal-colaborador.mis-documentos");
				break;
			case "/bandejaConsulta":
				setMenuActivo("bandejaConsulta");
				break;
			default:
				setMenuActivo(ruta);
		}
	}, []);

	let history = useHistory();

	function onClickMenuItem(opcion) {
		if (opcion === "bandejaEntrada") {
			setMenuActivo(opcion);
			if (getVersionApiColaborador() === VersionApiColaborador.v1) {
				history.push("/bandejaEntrada");
			} else {
				history.push("/mis-documentos");
			}
		} else if (opcion === "portal-colaborador.mis-documentos") {
			setMenuActivo(opcion);
			history.push("/mis-documentos");
		} else if (opcion === "portal-colaborador.v3.mis-pendientes") {
			setMenuActivo(opcion);
			history.push("/v3/mis-pendientes");
		} else if (opcion === "portal-colaborador.v3.mis-documentos") {
			setMenuActivo(opcion);
			history.push("/v3/mis-documentos");
		} else if (opcion === "bandejaConsulta") {
			// setMenuActivo(opcion);
			// if (
			// 	getVersionApiColaborador() === VersionApiColaborador.v1 ||
			// 	getVersionApiColaborador() === VersionApiColaborador.v2
			// ) {
			history.push("/bandejaConsulta");
			// }
		} else if (opcion === "portal-colaborador.vacaciones") {
			setMenuActivo(opcion);
			history.push("/vacaciones/solicitudes");
		} else if (opcion === "perfil") {
			setMenuActivo(opcion);
			history.push("/movil/perfil");
		} else if (opcion === "portal-colaborador.v3.mis-comunicaciones") {
			setMenuActivo(opcion);
			history.push("/v3/mi-portal");
		} else if (opcion === "menu") {
			setVisibleMenuPerfil(true);
		}
	}

	function onCloseMenuPerfil() {
		setVisibleMenuPerfil(false);
	}

	function onClickSalir() {
		setVisibleMenuPerfil(false);
		cerrarSesion();
	}
	function tieneAcceso(codigo) {
		return opciones?.includes(codigo);
	}

	function mostrarMenuItemMovil(identificador, nombre, icono, menuActivo, evento) {
		if (tieneAcceso(identificador)) {
			return (
				<MenuItemMovil
					identificador={identificador}
					titulo={nombre}
					icono={icono}
					menuActivo={menuActivo}
					onClick={evento}
				/>
			);
		}
		return null;
	}
	function onClickSolicitarPersonal() {
		setMenuActivo("portal-colaborador.solicitud-personal");
		history.push("/solicitud-personal");
		setVisibleMenuPerfil(false);
	}

	function onClickEntrevistas() {
		setMenuActivo("portal-colaborador.entrevistas");
		history.push("/entrevistas");
		setVisibleMenuPerfil(false);
	}

	function onClickTareasPendientes() {
		setMenuActivo("portal-colaborador.tareas-pendientes");
		history.push("/tareas-pendientes");
		setVisibleMenuPerfil(false);
	}

	const onClickBtnSeleccionarEmpresa = () => {
		history.push("/movil/configuracion/seleccionar-empresa");
		setVisibleMenuPerfil(false);
	};

	const onClickSolicitudDocumentos = () => {
		setMenuActivo("portal-colaborador.solicitud-documentos");
		history.push("/solicitud-documentos");
		setVisibleMenuPerfil(false);
	};

	const onClickFormatos = () => {
		setMenuActivo("portal-colaborador.formatos");
		history.push("/formatos");
		setVisibleMenuPerfil(false);
	};

	const onClickConsulta = () => {
		setMenuActivo("bandejaConsulta");
		history.push("/bandejaConsulta");
		setVisibleMenuPerfil(false);
	};

	const onClickBtnBeneficios = () => {
		setMenuActivo("beneficios");
		history.push("/comunicaciones-cultura/beneficios");
		setVisibleMenuPerfil(false);
	}

	const onClickRendimiento = () => {
		setMenuActivo("portal-colaborador.rendimiento");
		history.push("/comunicaciones-cultura/rendimiento");
		setVisibleMenuPerfil(false);
	}

	const onClickBtnPuntos = () => {
		setMenuActivo("puntos");
		history.push("/comunicaciones-cultura/puntos");
		setVisibleMenuPerfil(false);
	}

	return (
		<React.Fragment>
			<div className="container-movil-menu">
				{mostrarMenuItemMovil(
					"portal-colaborador.v3.mis-comunicaciones",
					"Comunicaciones",
					<ScheduleOutlined style={{ fontSize: "1.5rem" }} />,
					menuActivo,
					onClickMenuItem
				)}
				{mostrarMenuItemMovil(
					"bandejaEntrada",
					"Documentos",
					<FileTextOutlined style={{ fontSize: "1.5rem" }} />,
					menuActivo,
					onClickMenuItem
				)}
				{mostrarMenuItemMovil(
					"portal-colaborador.mis-documentos",
					"Documentos",
					<FileTextOutlined style={{ fontSize: "1.5rem" }} />,
					menuActivo,
					onClickMenuItem
				)}
				{mostrarMenuItemMovil(
					"portal-colaborador.v3.mis-pendientes",
					"Documentos Pendientes",
					<EditOutlined style={{ fontSize: "1.5rem" }} />,
					menuActivo,
					onClickMenuItem
				)}
				{mostrarMenuItemMovil(
					"portal-colaborador.v3.mis-documentos",
					"Mis Documentos",
					<FolderOpenOutlined style={{ fontSize: "1.5rem" }} />,
					menuActivo,
					onClickMenuItem
				)}
				{/* {mostrarMenuItemMovil(
					"bandejaConsulta",
					"Consultas",
					<ContainerOutlined style={{ fontSize: "1.5rem" }} />,
					menuActivo,
					onClickMenuItem
				)} */}
				{!isAceros && mostrarMenuItemMovil(
					"portal-colaborador.vacaciones",
					(isSDF || isSDFEnergia || isManuelita) ? "Movimiento del Personal":"Vacaciones",
					<CalendarOutlined style={{ fontSize: "1.5rem" }} />,
					menuActivo,
					onClickMenuItem
				)}
				{isAceros && mostrarMenuItemMovil(
					"portal-colaborador.vacaciones",
					"Ausentismos",
					<CalendarOutlined style={{ fontSize: "1.5rem" }} />,
					menuActivo,
					onClickMenuItem
				)}

				<MenuItemMovil
					identificador="perfil"
					titulo="Perfil"
					icono={<UserOutlined style={{ fontSize: "1.5rem" }} />}
					menuActivo={menuActivo}
					onClick={onClickMenuItem}
				/>

				<MenuItemMovil
					identificador="menu"
					titulo="Menú"
					icono={<AppstoreOutlined style={{ fontSize: "1.5rem" }} />}
					onClick={onClickMenuItem}
				/>
			</div>

			<Drawer
				title="Opciones"
				placement="right"
				onClose={onCloseMenuPerfil}
				open={visibleMenuPerfil}
				width={"80%"}
			>

				{tieneAcceso("portal-colaborador.puntos") && (
					<Button
						type="link"
						icon={<StarOutlined />}
						style={{
							padding: "0",
							display: "block",
							color: "#7d7d7d",
							fontSize: "16px",
						}}
						onClick={onClickBtnPuntos}
					>
						Puntos
					</Button>
				)}

				{tieneAcceso("portal-colaborador.beneficios") && (
					<Button
						type="link"
						icon={<StarOutlined />}
						style={{
							padding: "0",
							display: "block",
							color: "#7d7d7d",
							fontSize: "16px",
						}}
						onClick={onClickBtnBeneficios}
					>
						Beneficios
					</Button>
				)}

				{tieneAcceso("portal-colaborador.rendimiento") && (
					<Button
						type="link"
						icon={<LineChartOutlined />}
						style={{
							padding: "0",
							display: "block",
							color: "#7d7d7d",
							fontSize: "16px",
						}}
						onClick={onClickRendimiento}
					>
						Mis Rendimientos
					</Button>
				)}

				{tieneAcceso("portal-colaborador.solicitud-personal") && (
					<Button
						type="link"
						icon={<UsergroupAddOutlined />}
						style={{
							padding: "0",
							display: "block",
							color: "#7d7d7d",
							fontSize: "16px",
						}}
						onClick={onClickSolicitarPersonal}
					>
						Solicitud Personal
					</Button>
				)}

				{tieneAcceso("portal-colaborador.entrevistas") && (
					<Button
						type="link"
						icon={<ProfileOutlined />}
						style={{
							padding: "0",
							display: "block",
							color: "#7d7d7d",
							fontSize: "16px",
						}}
						onClick={onClickEntrevistas}
					>
						Entrevistas
					</Button>
				)}

				{tieneAcceso("portal-colaborador.tareas-pendientes") && (!isAceros && !isSDF && !isSDFEnergia)&& (
					<Button
						type="link"
						icon={<BarsOutlined />}
						style={{
							padding: "0",
							display: "block",
							color: "#7d7d7d",
							fontSize: "16px",
						}}
						onClick={onClickTareasPendientes}
					>
						Tareas Pendientes
					</Button>
				)}

				{(!isAceros && !isSDF)&& (
					<Button
						type="link"
						icon={<ProfileOutlined />}
						style={{
							padding: "0",
							display: "block",
							color: "#7d7d7d",
							fontSize: "16px",
						}}
						onClick={onClickBtnSeleccionarEmpresa}
					>
						Seleccionar Empresa
					</Button>
				)}


				{tieneAcceso("portal-colaborador.solicitud-documentos") && (
					<Button
						type="link"
						icon={<ProfileOutlined />}
						style={{
							padding: "0",
							display: "block",
							color: "#7d7d7d",
							fontSize: "16px",
						}}
						onClick={onClickSolicitudDocumentos}
					>
						Solicitud Documentos
					</Button>
				)}

				{tieneAcceso("portal-colaborador.formatos") && (
					<Button
						type="link"
						icon={<FormOutlined />}
						style={{
							padding: "0",
							display: "block",
							color: "#7d7d7d",
							fontSize: "16px",
						}}
						onClick={onClickFormatos}
					>
						Formatos
					</Button>
				)}

				<Divider />

				{tieneAcceso("bandejaConsulta") && (
					<Button
						type="link"
						icon={<MailOutlined />}
						style={{
							padding: "0",
							display: "block",
							color: "#7d7d7d",
							fontSize: "16px",
						}}
						onClick={onClickConsulta}
					>
						Consultas
					</Button>
				)}

				<Button
					type="link"
					icon={<ImportOutlined />}
					style={{
						padding: "0",
						display: "block",
						color: "#7d7d7d",
						fontSize: "16px",
					}}
					onClick={onClickSalir}
				>
					Salir
				</Button>
			</Drawer>
		</React.Fragment>
	);
}
